import {
    INVOICE_PAYMENT_GRID_DATA,
    INVOICE_PAYMENT_GRID_ERROR,
    INVOICE_PAYMENT_GRID_LOADING,
    INVOICE_PAYMENT_GRID_PAGE_CHANGE,
    INVOICE_PAYMENT_GRID_STATE_CHANGE,
} from "../constants";
import { makePrivateApiCall } from "utilities/dist/api";

export const loadPaymentGridPage = (state, grid) => dispatch => {
    let { lastRow, sortModel, filterModel } = state;

    dispatch({
        type: INVOICE_PAYMENT_GRID_LOADING,
    });

    const params = {
        endRow: grid.endRow,
        filterModel,
        sortModel,
        startRow: grid.startRow,
    };

    return makePrivateApiCall({
        url: "/invoice/payment/grid",
        method: "get",
        params,
    })
        .then(res => {
            if (res.data) {
                const payments = res.data.rows;
                lastRow = res.data.count;

                grid.successCallback(payments, lastRow);

                dispatch({
                    type: INVOICE_PAYMENT_GRID_DATA,
                    payload: { payments, lastRow },
                });
            }
        })
        .catch(err => {
            grid.failCallback(err);
            dispatch({
                type: INVOICE_PAYMENT_GRID_ERROR,
                payload: err.message,
            });
        });
};

export const changePaymentGridPage = page => {
    return {
        type: INVOICE_PAYMENT_GRID_PAGE_CHANGE,
        payload: page,
    };
};

export const changePaymentGridState = gridState => dispatch =>
    dispatch({
        type: INVOICE_PAYMENT_GRID_STATE_CHANGE,
        payload: gridState,
    });
